var file_upload_viewer_default = {
  "fontElementMap": "-nDMH",
  "file_upload_container": "NoTT8",
  "file_upload_link": "_2SobE",
  "file_upload_error_container": "DV0b9",
  "file_upload_file_info": "CfOjp",
  "file_upload_type_icon": "_6P15p",
  "file_upload_status_icon_container": "v1MHn",
  "file_upload_status_icon": "gVD1U",
  "file_upload_description": "mTWdh",
  "file_upload_name_container": "FXL5N",
  "file_upload_name": "NcrF-",
  "file_upload_extension": "VEccU",
  "file_loader_icon": "EaWsV",
  "file_upload_icon_frame": "BjsDK",
  "file_upload_icon_background": "LPTRo"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
